import type { BrandingConfig } from "@/lib/branding-context";
import { cn } from "@/lib/utils";

// The portal's logo slot. A partner's logo or name always wins; only when the
// MSP has neither does the portal show the DDMARC mark and name. Renders
// nothing while branding loads so a white-label host never flashes DDMARC.
const sizes = {
  lg: {
    logo: "h-12 w-auto",
    mark: "h-12 w-12",
    name: "font-display text-[28px] leading-none text-foreground",
  },
  sm: {
    logo: "h-7 w-auto",
    mark: "h-7 w-7",
    name: "font-display text-[18px] leading-none text-foreground",
  },
};

export function PortalBrand({
  branding,
  size,
}: {
  branding: BrandingConfig | null;
  size: keyof typeof sizes;
}) {
  const s = sizes[size];
  const Name = size === "lg" ? "h1" : "span";

  if (!branding) return null;

  if (branding.logo_url) {
    return (
      <img src={branding.logo_url} alt={branding.msp_name} className={s.logo} />
    );
  }

  if (branding.msp_name) {
    return <Name className={s.name}>{branding.msp_name}</Name>;
  }

  return (
    <div
      className={cn(
        "flex items-center",
        size === "lg" ? "flex-col gap-3" : "gap-2"
      )}
    >
      <img src="/brand/ddmarc-mark.svg" alt="" className={s.mark} />
      <Name className={s.name}>DDMARC portal</Name>
    </div>
  );
}
